import React from "react";
import { Box, Typography } from "@mui/material";

function VisitsChart({ visitsChartData, page, handleOpen }) {
  const width = page === "Lifestyle" ? "60%" : "85%";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // flex: 1,
          width: { width },
        }}
      >
        <Typography
          variant="p"
          align="left"
          sx={{ marginLeft: 2, fontSize: "15px", fontWeight: "bold" }}
        >
          Visits
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            width: { xl: "100%", lg: '100%', md: '90%' },
            py: 2,
            gap: 1,
            alignItems: "center",
            overflowX: "auto",
            justifyContent:page === "Lifestyle" ?"flex-start": handleOpen? {xl:'center', lg:'center', md:'flex-start'} : "center",
          }}
        >
          {visitsChartData?.map((data, index) => {
            if (data["isDue"] && data["isAttended"]) {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      height: handleOpen ? "36px" : '190px',
                      width: handleOpen ? "11px" : '25px',
                      backgroundColor: "#FF6445",
                      borderRadius: 10,
                      boxShadow: 3,
                      marginBottom: "5px",
                    }}
                  ></Box>
                  <Box display={"flex"} sx={{ alignSelf: 'center' }}>
                    <Typography fontSize={handleOpen ? "8px" : '12px'}  sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                  </Box>
                </Box>
              );
            } else if (data["isAttended"]) {
              return (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box
                    sx={{
                      height: handleOpen ? "36px" : '190px',
                      width: handleOpen ? "11px" : '25px',
                      backgroundColor: "#C8EDF5",
                      borderRadius: 10,
                      boxShadow: 3,
                      marginBottom: "5px",
                    }}
                  ></Box>
                  <Box display={"flex"} sx={{ alignSelf: 'center' }}>
                    <Typography fontSize={handleOpen ? "8px" : '12px'} sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                  </Box>
                </Box>
              );
            } else {
              return (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box
                    sx={{
                      height: handleOpen ? "36px" : '190px',
                      width: handleOpen ? "11px" : '25px',
                      backgroundColor: "#b6c0c4ff",
                      borderRadius: 10,
                      boxShadow: 3,
                      marginBottom: "5px",
                    }}
                  ></Box>
                  <Box display={"flex"} sx={{ alignSelf: 'center' }}>
                    <Typography fontSize={handleOpen ? "8px" : '12px'}  sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                  </Box>
                </Box>
              );
            }
          })}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "left",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", mb: 1 }}>
          <Box
            sx={{
              width: handleOpen ? 6 : 12,
              height: handleOpen ? 6 : 12,
              backgroundColor: "#FF6445",
              borderRadius: handleOpen ? 6 : 12,
            }}
          ></Box>
          <Typography
            variant="p"
            fontSize={handleOpen ? "6px" : '12px'}
            marginLeft={0.5}
            marginRight={1}
          >
            Visited
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            sx={{
              width: handleOpen ? 6 : 12,
              height: handleOpen ? 6 : 12,
              backgroundColor: "#C8EDF5",
              borderRadius: handleOpen ? 6 : 12,
            }}
          ></Box>
          <Typography
            variant="p"
            fontSize={handleOpen ? "6px" : '12px'}
            marginLeft={0.5}
          // marginRight={1}
          >
            Not Visited
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default VisitsChart;
